import { ReviewsPlace } from "../models/reviews/reviewPlace";

const useReviews = () => {
  const getReviews = (placeId: string): ReviewsPlace | undefined => {
    const data = require("../../src/reviewsCache.json");

    const reviewPlaces: ReviewsPlace[] = JSON.parse(JSON.stringify(data));

    const place = reviewPlaces.find(i => i.id === placeId);

    return place;
  };

  return [getReviews] as const;
};

export default useReviews;
